/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertAdapter, FullScreenLoading, RegularButton } from 'pg-ui-library';
import Arrow from 'src/assets/arrow-left-black.svg';
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useMutation, useQuery } from '@tanstack/react-query';
import BenefitsService, { IEnrollmentPost } from 'src/services/benefits.service';

import { useLocation, useNavigate } from 'react-router-dom';
import { useActions } from 'src/hooks/useActions';
import { DependentsSettings, IBenefit, IBenefitsReview, ICartBenefit, LifeInsuranceSettings } from 'src/interfaces';
import { SignSubmitModal } from '../sign-submit-modal';

import {
  ArrowBack,
  BeneficiariesContainer,
  Body,
  ColumnHeader,
  Container,
  Footer,
  FooterItemLeft,
  FooterText,
  Header,
  HeaderItemLeft,
  NavTextLink,
  PageTitle,
  RelativeContainer,
  TooltipText,
  Wrapper,
} from './styles';
// import jsonData from './mocks/enroll-details.mock.json';
import './styles.css';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

export const BenefitsReview = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<IBenefitsReview[]>([]);

  const { addBenefitToCart, clearCart } = useActions();

  const [filteredData, setFilteredData] = useState<IBenefitsReview[]>([]);
  const [openSignSubmitModal, setOpenSignSubmitModal] = useState(false);
  const { cart, categoriesToElect } = useTypedSelector(state => state.benefits.data);
  const { personalInfo } = useTypedSelector(state => state.personalInfo.data);
  const { isLoading, data: benefits } = useQuery({
    queryKey: ['benefits/available-benefits'],
    queryFn: () => BenefitsService.getBenefits(),
    enabled: true,
  });

  const waiveAllNonSelected = (benefit: IBenefitsReview[]) => {
    const userChoiceToProceed = confirm(
      'This action will Waive all Non-Enrolled benefits, are you sure you want to proceed?'
    );

    if (userChoiceToProceed) {
      let declinedList: ICartBenefit[] = [];

      for (const singleBenefit of benefit) {
        if (singleBenefit.status == 'Not Selected') {
          const declinedBenefit: ICartBenefit = {
            generalCategory: '',
            type: singleBenefit.type || '',
            benefitId: '',
            imgURL: '',
            planDescription: singleBenefit.type || '',
            optionDescription: 'Declined',
            price: 0,
            expiration: '',
            action: 'DECLINED',
            benefitName: singleBenefit.type || '',
            benefitPlanId: '',
            benefitOptionId: '',
            benefitEnrollmentStart: '',
            benefitEnrollmentEnd: '',
            benefitProvider: '',
            employeeName: '',
            employeeCost: 0,
            employerName: '',
            employerCost: 0,
            percent: 0,
            fixedAmount: 0,
            dependents: '',
            employeeChoosesPayment: null,
          };
          declinedList.push({ ...declinedBenefit });
        }
      }
      addBenefitToCart(declinedList);
      AlertAdapter('You waived all non-selected benefits', 'success');
    }
  };

  const columns: TableColumn<IBenefitsReview>[] = [
    {
      name: <ColumnHeader>Benefit ID</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.benefitId,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Plan ID</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.plan,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Employee ID</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.employeeId,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Employee Name</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.employeeName,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Dependent Included</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.dependentIncluded,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Dependents</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.dependents,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Smoker</ColumnHeader>,
      selector: (row: IBenefitsReview) => (row.smoker ? row?.smoker : ''),
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Beneficiaries</ColumnHeader>,
      cell: (row: IBenefitsReview) => {
        const data = row.beneficiaries.split(',');

        return (
          <Wrapper>
            <BeneficiariesContainer>
              {data.map((bnf, i) => (
                <p
                  key={i}
                  style={{
                    margin: 0,
                  }}
                >
                  {bnf}
                </p>
              ))}
            </BeneficiariesContainer>
            <RelativeContainer id="tooltip">
              <TooltipText>
                {data.map((bnf, i) => (
                  <div key={i}>
                    <br />
                    {bnf}
                  </div>
                ))}
              </TooltipText>
            </RelativeContainer>
          </Wrapper>
        );
      },
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Type</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.type,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Status</ColumnHeader>,
      selector: (row: IBenefitsReview) => row.status,
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Semi-Monthly</ColumnHeader>,
      selector: (row: IBenefitsReview) => monetaryUSDFormat(row.price),
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Monthly Price</ColumnHeader>,
      selector: (row: IBenefitsReview) => monetaryUSDFormat(row.price * 2),
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Annual Cost</ColumnHeader>,
      selector: (row: IBenefitsReview) => monetaryUSDFormat(row.price * 24),
      sortable: true,
      wrap: true,
    },
    {
      name: <ColumnHeader>Coverage Amount</ColumnHeader>,
      selector: (row: IBenefitsReview) => monetaryUSDFormat(row.coverageAmount),
      sortable: true,
      wrap: true,
    },
  ];

  const checkAllCategoriesToElect = async (data: IBenefitsReview[]) => {
    const matchedData: IBenefitsReview[] = data.filter(cartItem => {
      let found = false;
      for (const category of benefits?.categoriesToElect as unknown as string[]) {
        if (cartItem.type === category) {
          found = true;
        }
      }
      if (found) {
        return cartItem;
      } else {
      }
    });
    return matchedData;
  };

  const electedOrDeclinedTypes = cart?.map(b => b.type) || [];

  const notSelectedCategories = categoriesToElect?.filter(item => !electedOrDeclinedTypes.includes(item));

  const notSelected: IBenefitsReview[] =
    notSelectedCategories?.map(type => ({
      benefitId: '',
      plan: '',
      employeeId: personalInfo?.employeeNickId || '',
      employeeName: `${personalInfo?.firstName} ${personalInfo?.middleName} ${personalInfo?.lastName}`,
      dependentIncluded: '',
      dependents: '',
      beneficiaries: '',
      type,
      status: 'Not Selected',
      price: 0,
      annualCost: 0,
      coverageAmount: 0,
    })) || [];

  const checkSmokerColumn = (benefit: ICartBenefit) => {
    if (benefit.hasSmokerOption) {
      return benefit.smoker ? 'Yes' : 'No';
    }
    return '';
  };

  const electedData: IBenefitsReview[] =
    cart
      ?.filter(d => d.action === 'ADD')
      .map(b => ({
        benefitId: b.benefitId,
        plan: b.planDescription,
        employeeId: personalInfo?.employeeNickId || '',
        employeeName: `${personalInfo?.firstName} ${personalInfo?.middleName} ${personalInfo?.lastName}`,
        dependentIncluded: b.dependents,
        dependents: (b.settings?.data as DependentsSettings)?.dependents
          ? (b.settings?.data as DependentsSettings).dependents.map(be => be.name).join(',')
          : '',
        beneficiaries:
          b.necessaryToProvideBeneficiariesInformation && (b.settings?.data as LifeInsuranceSettings)?.beneficiaries
            ? (b.settings?.data as LifeInsuranceSettings).beneficiaries
                .map(be => `${be.name} = ${be.percentToPay}%`)
                .join(',')
            : '',
        type: b.type,
        status: 'Elected',
        price: b.price,
        annualCost: b.price * 24,
        coverageAmount: b.coverageAmount ?? 0,
        smoker: checkSmokerColumn(b),
        beneficiaryInfo:
          b.necessaryToProvideBeneficiariesInformation && (b.settings?.data as LifeInsuranceSettings)?.beneficiaries
            ? (b.settings?.data as LifeInsuranceSettings).beneficiaries.map(be => ({
                personId: be.personId,
                percentage: be.percentToPay.toString(),
              }))
            : [],
        dependentsInfo: (b.settings?.data as DependentsSettings)?.dependents
          ? (b.settings?.data as DependentsSettings).dependents.map(be => ({
              personId: be.personId,
            }))
          : [],
      })) ?? [];

  const removedBenefitsData: IBenefitsReview[] =
    cart
      ?.filter(d => d.action === 'REMOVE')
      .map(b => ({
        benefitId: b.benefitId,
        plan: b.planDescription,
        employeeId: personalInfo?.employeeNickId || '',
        employeeName: `${personalInfo?.firstName} ${personalInfo?.middleName} ${personalInfo?.lastName}`,
        dependentIncluded: b.dependents,
        dependents: (b.settings?.data as DependentsSettings)?.dependents
          ? (b.settings?.data as DependentsSettings).dependents.map(be => be.name).join(',')
          : '',
        beneficiaries:
          b.necessaryToProvideBeneficiariesInformation && (b.settings?.data as LifeInsuranceSettings)?.beneficiaries
            ? (b.settings?.data as LifeInsuranceSettings).beneficiaries
                .map(be => be.name + ' = ' + be.percentToPay + '%')
                .join(',')
            : '',
        type: b.type,
        status: 'Removed',
        price: b.price,
        annualCost: b.price * 24,
        coverageAmount: b.coverageAmount ?? 0,
      })) || [];

  const waivedData: IBenefitsReview[] =
    cart
      ?.filter(d => d.action === 'DECLINED')
      .map(b => ({
        benefitId: b.benefitId,
        plan: b.planDescription,
        employeeId: personalInfo?.employeeNickId || '',
        employeeName: `${personalInfo?.firstName} ${personalInfo?.middleName} ${personalInfo?.lastName}`,
        dependentIncluded: b.dependents,
        dependents: '',
        beneficiaries: '',
        type: b.type,
        status: 'Waived',
        price: b.price,
        annualCost: b.price * 24,
        coverageAmount: 0, // TODO
      })) || [];

  useEffect(() => {
    const fetchData = async () => {
      const matched = await checkAllCategoriesToElect([
        ...electedData,
        ...removedBenefitsData,
        ...waivedData,
        ...notSelected,
      ]);
      setData(matched);
      setFilteredData(matched);
    };
    fetchData();
  }, [cart, benefits?.categoriesToElect]);

  const navigate = useNavigate();

  const location = useLocation();

  const stateData = location.state as {
    event: 'new_hire' | 'open_enrollment' | 'qle' | 'update_enrollment';
    qle?: {
      files: FileList;
      lifeEvent: string;
      description: string;
      eventDate: string | Date;
    };
  };

  const totalAddedToCart = cart
    ?.filter(benefit => benefit.action === 'ADD')
    ?.map(benefit => benefit.price)
    .reduce((acc, next) => Number(acc) + Number(next), 0) as unknown as 0;

  const enrollDetails = () => {
    const electBenefits = data.filter(b => b.status === 'Elected' || b.status === 'Removed');
    setFilteredData(electBenefits);
  };

  const waiveDetails = () => {
    const electBenefits = data.filter(b => b.status === 'Waived');
    setFilteredData(electBenefits);
  };

  const notSelectedBenefitsDetails = () => {
    const notSelectedBenefits = data.filter(b => b.status === 'Not Selected');
    setFilteredData(notSelectedBenefits);
  };

  const resetFilters = () => {
    setFilteredData([...data]);
  };

  const downloadReview = () => {
    exportToXLSX(data || [], 'enrolldetails', 'enroll-detail');
  };

  const openEnrollmentMutation = useMutation((cartData: IEnrollmentPost) =>
    BenefitsService.enrollForOpenEnrollment(cartData)
  );

  const newHireEnrollmentMutation = useMutation((cartData: IEnrollmentPost) =>
    BenefitsService.enrollForNewHire(cartData)
  );

  const updateEnrollmentMutation = useMutation((cartData: IEnrollmentPost) =>
    BenefitsService.enrollForUpdateEnrollment(cartData)
  );

  const submitNewHireEnrollment = async () => {
    try {
      if (!cart) {
        AlertAdapter(t('benefits.newHire.emptyCart.line1'), 'error');
        return;
      }

      const addedBenefitIds = cart.filter(benefit => benefit.action === 'ADD');

      await newHireEnrollmentMutation.mutateAsync({
        removed: [], // there´s no remove option on new hire
        added: addedBenefitIds.map(item => ({
          benefitId: item.benefitId,
          ...item.settings?.data,
        })),
        summary: data,
      });
      clearCart();
      navigate('/benefits', { replace: true });
      AlertAdapter(t('benefits.newHire.submitSuccess'), 'success');
    } catch (e: any) {
      AlertAdapter(e.response.data.message, 'error');
    }
  };

  const submitOpenEnrollment = async () => {
    try {
      if (!cart) {
        AlertAdapter(t('benefits.openEnrollment.emptyCart.line1'), 'error');
        return;
      }

      const removedBenefitIds = cart.filter(benefit => benefit.action === 'REMOVE');
      const addedBenefitIds = cart.filter(benefit => benefit.action === 'ADD');

      await openEnrollmentMutation.mutateAsync({
        removed: removedBenefitIds.map(item => item.benefitId),
        added: addedBenefitIds.map(item => ({
          benefitId: item.benefitId,
          ...item.settings?.data,
        })),
        summary: data,
      });
      clearCart();
      navigate('/benefits', { replace: true });
      AlertAdapter(t('benefits.openEnrollment.submitSuccess'), 'success');
    } catch (e: any) {
      AlertAdapter(e.response.data.message, 'error');
    }
  };

  const enrollmentMutation = useMutation((data: FormData) => BenefitsService.enrollForQle(data));

  const [qleData] = useLocalStorage('qleData', null);

  const submitQLEEnrollment = async () => {
    try {
      if (!cart) {
        AlertAdapter(t('benefits.qualifyingLifeEvent.emptyCart.line1'), 'error');
        return;
      }

      const removedBenefitIds = cart.filter(benefit => benefit.action === 'REMOVE');
      const addedBenefitIds = cart.filter(benefit => benefit.action === 'ADD');

      const values = {
        ...qleData,
        files: stateData.qle?.files,
        removed: removedBenefitIds,
        added: addedBenefitIds.map(item => ({
          benefitId: item.benefitId,
          ...item.settings?.data,
        })),
        summary: data,
      };
      const fd = new FormData();

      if (values.files) {
        for (let index = 0; index < values.files.length; index++) {
          const file = values.files[index];
          if (file) {
            fd.append('files', file, file?.name || '');
          }
        }
      }

      if (values.removed) {
        for (let index = 0; index < values.removed.length; index++) {
          fd.append(`removed[${index}][benefitId]`, values.removed[index].benefitId);
        }
      }

      if (values.added) {
        fd.append(`added`, JSON.stringify(values.added));
      }

      if (values.lifeEvent) {
        fd.append('lifeEvent', values.lifeEvent);
      }

      if (values.eventDate) {
        fd.append('eventDate', values.eventDate as string);
      }

      if (values.description) {
        fd.append('description', values.description);
      }

      fd.append('summary', JSON.stringify(data));
      await enrollmentMutation.mutateAsync(fd);
      clearCart();

      navigate('/benefits', { replace: true });
      AlertAdapter(t('benefits.qualifyingLifeEvent.submitSuccess'), 'success');
    } catch (e) {
      AlertAdapter(t('benefits.qualifyingLifeEvent.submitError'), 'error');
    }
  };

  const submitUpdateEnrollment = async () => {
    try {
      if (!cart) {
        AlertAdapter(t('benefits.updateEnrollment.emptyCart.line1'), 'error');
        return;
      }

      const addedBenefitIds = cart.filter(benefit => benefit.action === 'ADD');

      await updateEnrollmentMutation.mutateAsync({
        removed: [], // there´s no remove option on new hire
        added: addedBenefitIds.map(item => ({
          benefitId: item.benefitId,
          ...item.settings?.data,
        })),
        summary: data,
      });

      navigate('/benefits', { replace: true });

      AlertAdapter(t('benefits.updateEnrollment.submitSuccess'), 'success');
    } catch (e) {
      AlertAdapter(t('benefits.updateEnrollment.submitError'), 'error');
    }
  };

  const submitCartEnrollment = async () => {
    if (stateData.event === 'new_hire') {
      submitNewHireEnrollment();
    }
    if (stateData.event === 'open_enrollment') {
      submitOpenEnrollment();
    }
    if (stateData.event === 'qle') {
      submitQLEEnrollment();
    }
    if (stateData.event === 'update_enrollment') {
      submitUpdateEnrollment();
    }
  };

  return (
    <Container>
      {(openEnrollmentMutation.isLoading || newHireEnrollmentMutation.isLoading || enrollmentMutation.isLoading) && (
        <FullScreenLoading />
      )}
      <Header>
        <HeaderItemLeft>
          <NavTextLink to={-1 as any}>
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <PageTitle>{t('benefits.review.title')}</PageTitle>
        </HeaderItemLeft>

        <div>
          <RegularButton type="button" onClick={resetFilters}>
            {t('global.form.all')}
          </RegularButton>
          <RegularButton type="button" onClick={notSelectedBenefitsDetails}>
            {t('benefits.review.nonEnrolled')}
          </RegularButton>

          <RegularButton type="button" onClick={enrollDetails}>
            {t('benefits.review.enrollDetails')}
          </RegularButton>
          <RegularButton type="button" onClick={waiveDetails}>
            {t('benefits.review.waiveDetails')}
          </RegularButton>
          <RegularButton type="button" onClick={downloadReview}>
            {t('benefits.review.downloadReview')}
          </RegularButton>
          <RegularButton
            onClick={e => {
              waiveAllNonSelected(notSelected);
            }}
          >
            {t('benefits.review.waiveAll')}
          </RegularButton>
        </div>
      </Header>
      <Body>
        <DefaultTable columns={columns} data={filteredData} pagination paginationPerPage={30} />
      </Body>
      <Footer>
        <FooterItemLeft>
          <RegularButton
            type="button"
            disabled={notSelected.length > 0}
            onClick={() => {
              setOpenSignSubmitModal(prevValue => !prevValue);
            }}
          >
            {t('benefits.review.signAndSubmit')}
          </RegularButton>
          <FooterText>{t('benefits.review.waiveAlert')}</FooterText>
        </FooterItemLeft>
        <RegularButton type="button">
          {t('benefits.review.totalOnCart')}
          {monetaryUSDFormat(totalAddedToCart)}
        </RegularButton>
      </Footer>
      <SignSubmitModal
        isOpen={openSignSubmitModal}
        onCloseSuccess={submitCartEnrollment}
        onRequestClose={() => setOpenSignSubmitModal(false)}
      />
    </Container>
  );
};
